import { Box, Card, IconButton, useTheme } from '@mui/material'

import { useContext, useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next' // LAP-733 (GE022)
import CustomButton from '../../../../Components/CustomButton/CustomButton'
import WTypography from '../../../../Components/whiteTypography'
import { AppContext } from '../../../../context'
import EAlimentationChart from '../Charts/EAlimentationChart'
import EAlimentationDonut from '../Charts/EAlimentationDonut'
import BarCIcone from '../Icone/bar_chart_white_24dp.svg'
import DonutCIcone from '../Icone/donut_small_white_24dp.svg'
import QuestionAnswerForm from './QuestionAnswerForm'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faInfo } from '@fortawesome/free-solid-svg-icons/faInfo'
import RestaurantIcon from '@mui/icons-material/Restaurant'
import EcoEmptyShortcut from './EcoEmptyShortcut'

function EAlimentationCard({ oldData, updateBoard }) {
  const { t } = useTranslation('layout') // LAP-733 (GE022)
  const [open, setOpen] = useState(false)
  const theme = useTheme()
  const [optionChart, setOptionChart] = useState(false)
  const [reports, setReports] = useState()
  const [headerValue, setHeaderValue] = useState(null)
  const { tableAccount } = useContext(AppContext)
  const navigate = useNavigate()
  const location = useLocation()

  useEffect(() => {}, [])
  useEffect(() => {
    const params = new URLSearchParams(location.search)
    if (location.hash === '#alimentation' || params.get('questionnaire') === 'alimentation') {
      setOpen(true)
    }
  }, [location.hash, location.search])

  const hasData = oldData?.length > 0 && oldData?.[0]?.byfoodcat?.length > 0

  return (
    <Card className="dashboard_card__root1">
      <Box className="dashboard_card__header1">
        <WTypography component={'span'} variant="h6">
          {t('dashboard.emissionAlimentation') /* LAP-733 (GE022) */}
        </WTypography>
        <WTypography component={'span'} variant="h6">
          {headerValue}
          <WTypography
            component={'span'}
            sx={{ fontSize: '12px', color: 'white', marginLeft: '4px' }}
          >
            t. CO<sup>2</sup>/an
          </WTypography>
        </WTypography>
      </Box>

      <Box mt={3} minWidth={3} mb={6} height={'100%'} className="no-drag">
        {!hasData ? (
          <EcoEmptyShortcut
            icon={<RestaurantIcon sx={{ fontSize: 31 }} />}
            description={t('dashboard.emptyAlimentationDesc') /* LAP-733 (GE022) */}
            buttonLabel={t('dashboard.emptyAlimentationBtn') /* LAP-733 (GE022) */}
            onClick={() => setOpen(true)}
          />
        ) : optionChart ? (
          <EAlimentationChart
            setHeaderValue={setHeaderValue}
            open={open}
            setOpen={setOpen}
            reports={reports ? reports : oldData}
          />
        ) : (
          <Box mt={10} className="chart_box" minWidth={3} mb={6} height={'100%'}>
            <EAlimentationDonut
              setHeaderValue={setHeaderValue}
              open={open}
              setOpen={setOpen}
              reports={reports ? reports : oldData}
            />
          </Box>
        )}
      </Box>

      {(hasData || open) && (
        <Box mt={2} className="dashboard_card__filters1">
          <Box className="no-drag" mr={2}>
            <QuestionAnswerForm
              open={open}
              setOpen={setOpen}
              startIcon={<FontAwesomeIcon icon={faInfo} />}
              setReports={setReports}
              updateBoard={updateBoard}
            />
            {optionChart ? (
              <IconButton onClick={() => setOptionChart(false)}>
                <img src={DonutCIcone} alt="DonutChart" className="Optionbutton"></img>
              </IconButton>
            ) : (
              <IconButton onClick={() => setOptionChart(true)}>
                <img src={BarCIcone} alt="BarChart" className="Optionbutton"></img>
              </IconButton>
            )}
          </Box>
        </Box>
      )}
    </Card>
  )
}

export default EAlimentationCard
